import React from 'react'
import { Navigate } from 'react-router-dom'
import '../../../css/public/pages/login.css'
import Form from './form';
import { firstAllowedPath } from '../../../configTools/permissions';

const Index = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    if(User){
        if(User.role === 'admin'){
            return <Navigate to={'/admin'}/>
        }
        else if(User.role === 'labadmin'){
            return <Navigate to={"/labadmin"}/>
        }
        else if(User.role === 'doctor'){
            return <Navigate to={"/doctor"}/>
        }
        else if(User.role === 'employee'){
            // Straight to the first page they are allowed to open. '/labadmin' would redirect to
            // the dashboard, which most employees will not have, bouncing them back here.
            const landing = firstAllowedPath(User);
            if(landing){
                return <Navigate to={landing}/>
            }
            // Signed in but granted nothing. Showing the form again would look like the password
            // was wrong, so say what actually happened.
            return (
                <div style={{padding:'60px 20px', textAlign:'center', fontSize:'14px', color:'#4a4a4a'}}>
                    <p>Your account does not have access to any pages yet.</p>
                    <p style={{fontSize:'12px', color:'#8a8a8a', paddingTop:'8px'}}>
                        Ask your lab administrator to grant access, then sign in again.
                    </p>
                    <p style={{paddingTop:'16px'}}>
                        <a href='/signout' style={{color:'#5c3da9', fontSize:'13px'}}>Sign out</a>
                    </p>
                </div>
            );
        }
        else{
            return <Navigate to={"/"}/>
        }
    }
    else{
        // authGuard.js appends this when the API refuses the stored session. Without a word of
        // explanation an automatic sign-out looks like the app crashed or logged them off at
        // random; this says it was deliberate and what to do next.
        const expired = window.location.search.indexOf('expired=1') !== -1;
        return (
          <>
            {expired &&
                <p style={{margin:'0 auto', maxWidth:'420px', padding:'10px 14px',
                           border:'1px solid #d9c7c7', background:'#fdf4f4', color:'#922724',
                           fontSize:'13px', letterSpacing:'normal', textAlign:'center'}}>
                    Your session has ended. Please sign in again.
                </p>
            }
            <Form/>
          </>
        )
    }
}

export default Index
